var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildTitle, buildStandardMeta, buildOgMeta, buildLink, buildOgMetaRefs, buildStructuredData, } from '../../types/builders';
import adapter from './adapter-blog-category';
import { siteIDs } from '../../adapters/utils';
import blogCategoryCollection from './schema-presets/blog-category-collection';
var IDs = adapter.IDs;
export var BLOG_CATEGORY = {
    tags: __spreadArrays([
        buildTitle("{{" + IDs.NAME + "}}")
    ], buildOgMetaRefs(), [
        buildOgMeta('og:url', "{{" + IDs.PAGE_URL + "}}"),
        buildOgMeta('og:site_name', "{{" + siteIDs.BUSINESS_NAME + "}}"),
        buildOgMeta('og:type', 'website'),
        buildOgMeta('og:image', "{{" + IDs.IMAGE + "}}"),
        buildOgMeta('og:image:height', "{{" + IDs.IMAGE_HEIGHT + "}}"),
        buildOgMeta('og:image:width', "{{" + IDs.IMAGE_WIDTH + "}}"),
        buildStandardMeta('robots', 'index'),
        buildLink('canonical', "{{" + IDs.PAGE_URL + "}}"),
        buildLink('prevUrl', "{{" + IDs.PREV_PAGE_URL + "}}"),
        buildLink('nextUrl', "{{" + IDs.NEXT_PAGE_URL + "}}"),
        buildStructuredData({
            schema: blogCategoryCollection.schema,
            schemaType: blogCategoryCollection.type,
            disabled: [
                "{{" + IDs.SD_DISABLE_SCHEMA + "}}",
                '{{options.disable-pattern-schema}}',
            ],
        }),
    ]),
};
